import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider, createTheme, CssBaseline } from '@mui/material';
import { AuthProvider, useAuth } from './context/AuthContext';
import Layout from './components/Layout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Employees from './pages/employees/Employees';
import EmployeeDetail from './pages/employees/EmployeeDetail';
import AttendanceMonthDetail from './pages/employees/AttendanceMonthDetail';
import Attendance from './pages/attendance/Attendance';
import Salary from './pages/salary/Salary';
import Leave from './pages/leave/Leave';
import Holidays from './pages/holidays/Holidays';
import Departments from './pages/departments/Departments';
import Notifications from './pages/notifications/Notifications';
import ExcelExport from './pages/exports/ExcelExport';
import Sessions from './pages/sessions/Sessions';
import Users from './pages/users/Users';
import AuditLogs from './pages/audit/AuditLogs';

const theme = createTheme({
  palette: {
    primary: { main: '#1a237e' },
    secondary: { main: '#1565c0' },
    background: { default: '#f5f6fa' },
  },
  typography: {
    fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
  },
  components: {
    MuiButton: { styleOverrides: { root: { textTransform: 'none' } } },
    MuiTextField: { defaultProps: { variant: 'outlined' } },
  },
});

const PrivateRoute = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) return null;
  return user ? <Layout>{children}</Layout> : <Navigate to="/login" replace />;
};

const PublicRoute = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) return null;
  return user ? <Navigate to="/dashboard" replace /> : children;
};

export default function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<PublicRoute><Login /></PublicRoute>} />
            <Route path="/dashboard" element={<PrivateRoute><Dashboard /></PrivateRoute>} />
            <Route path="/employees" element={<PrivateRoute><Employees /></PrivateRoute>} />
            <Route path="/employees/:id" element={<PrivateRoute><EmployeeDetail /></PrivateRoute>} />
            <Route path="/employees/:id/attendance/:month/:year" element={<PrivateRoute><AttendanceMonthDetail /></PrivateRoute>} />
            <Route path="/attendance" element={<PrivateRoute><Attendance /></PrivateRoute>} />
            <Route path="/salary" element={<PrivateRoute><Salary /></PrivateRoute>} />
            <Route path="/users" element={<PrivateRoute><Users /></PrivateRoute>} />
            <Route path="/leave" element={<PrivateRoute><Leave /></PrivateRoute>} />
            <Route path="/holidays" element={<PrivateRoute><Holidays /></PrivateRoute>} />
            <Route path="/departments" element={<PrivateRoute><Departments /></PrivateRoute>} />
            <Route path="/notifications" element={<PrivateRoute><Notifications /></PrivateRoute>} />
            <Route path="/exports" element={<PrivateRoute><ExcelExport /></PrivateRoute>} />
            <Route path="/sessions" element={<PrivateRoute><Sessions /></PrivateRoute>} />
            <Route path="/audit" element={<PrivateRoute><AuditLogs /></PrivateRoute>} />
            <Route path="*" element={<Navigate to="/dashboard" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </ThemeProvider>
  );
}
